export const MY_IDENTITY_STORE_REQUEST_URL =
  "https://myidentity.apps.ikea.com/IdentityManager/page.axd?RuntimeFormID=66b60508-798f-40f9-8504-ea6b94727765&aeweb_handler=p&aeweb_rp=&wproj=0&ContextID=CCC_ITShop_PWOSelection";
